export const RATE_PLANS_DATA_FETCHER_ACTIONS = {
    FETCH_SUCCESS: "FETCH_SUCCESS",
    FETCH_FAILED: "FETCH_FAILED"
};